(function () {
  'use strict';

  var FADE_OUT = 280;
  var FADE_IN = 420;
  var FIRST_SLIDE_DELAY = 2000;
  var TAG = '[oranvelle-slideshow]';

  function setup(el) {
    if (!el || el.dataset.orvReady === '1') return;

    var slider = el.querySelector('.slider.slideshow');
    if (!slider) { console.warn(TAG, 'no .slider.slideshow'); return; }

    var slides = slider.querySelectorAll('.slideshow__slide');
    if (slides.length < 2) { console.warn(TAG, 'need 2+ slides, got', slides.length); return; }

    el.dataset.orvReady = '1';

    if (typeof el.pause === 'function') el.pause();
    el.autoplayButtonIsSetToPlay = false;
    el.play = function () {};
    el.pause = function () {};

    Array.prototype.forEach.call(slider.querySelectorAll('img'), function (img) {
      img.removeAttribute('loading');
    });

    slider.style.scrollBehavior = 'auto';

    Array.prototype.forEach.call(el.querySelectorAll('.slideshow__controls'), function (bar) {
      bar.style.display = 'none';
    });

    var stale = el.querySelector('.orv-curtain');
    if (stale) stale.remove();

    el.style.backgroundColor = '#000';
    slider.style.willChange = 'opacity';

    var index = 0;
    var busy = false;
    var timer = null;
    var firstTimer = null;
    var dwell = (parseFloat(slider.dataset.speed) || 5) * 1000;

    function stepWidth() {
      var w = slides[1].offsetLeft - slides[0].offsetLeft;
      if (!w || isNaN(w)) w = slider.clientWidth;
      return w;
    }

    function goTo(next) {
      if (busy) return;
      busy = true;

      slider.style.transition = 'opacity ' + FADE_OUT + 'ms cubic-bezier(.4,0,1,1)';
      slider.style.opacity = '0';

      setTimeout(function () {
        index = next;
        slider.scrollLeft = index * stepWidth();

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            slider.style.transition = 'opacity ' + FADE_IN + 'ms cubic-bezier(0,0,.2,1)';
            slider.style.opacity = '1';
            setTimeout(function () { busy = false; }, FADE_IN);
          });
        });
      }, FADE_OUT);
    }

    function advance() { goTo((index + 1) % slides.length); }

    function start() {
      stop();
      firstTimer = setTimeout(function () {
        advance();
        timer = setInterval(advance, dwell);
      }, FIRST_SLIDE_DELAY);
    }

    function stop() {
      if (firstTimer) { clearTimeout(firstTimer); firstTimer = null; }
      if (timer) { clearInterval(timer); timer = null; }
    }

    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    start();
  }

  function bootAll() {
    Array.prototype.forEach.call(document.querySelectorAll('slideshow-component'), setup);
  }

  function ready() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('slideshow-component').then(bootAll);
    } else {
      bootAll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector
      ? e.target.querySelector('slideshow-component')
      : null;
    if (el) {
      delete el.dataset.orvReady;
      setTimeout(function () { setup(el); }, 0);
    }
  });
})();
